import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { FeedbackService } from '~/service/service.feedback';
import { PostService } from '~/service/service.post';
import { useService } from '~/shared/service/service.base';
import { Col, Row } from '../view.box';
import { LinkView } from '../view.link';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';

export const FeedbackDrawerPost = observer(() => {
	const [{ selectedItem, reload }, postSvc, auth] = useService(FeedbackService, PostService, AuthService);
	if (!selectedItem) return false;

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Complaint:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem.complaint}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('post', 'READ')}
					to={AppRoutes.PostEdit.buildPath({ id: selectedItem?.postId ?? 0 })}
					target="_blank"
				>
					{selectedItem.postId}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post author:</FeedbackDrawerTitle>
				<LinkView
					disabled={!auth.can('user', 'READ')}
					to={AppRoutes.UserEdit.buildPath({ id: selectedItem?.postAuthorId ?? 0 })}
					target="_blank"
				>
					{selectedItem.postAuthor}
				</LinkView>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post text:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.postText}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Post moderation:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.postModeration}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			{selectedItem.postAuthorId ? (
				<Row mt={2} gap={1}>
					{selectedItem?.postModeration !== 'HIDDEN' ? (
						<Button
							fullWidth
							variant="contained"
							disabled={!auth.can('post', 'UPDATE')}
							onClick={() => selectedItem?.postId && postSvc.hide(selectedItem.postId).done(reload)}
						>
							Hide post
						</Button>
					) : (
						<Button
							fullWidth
							variant="contained"
							disabled={!auth.can('post', 'UPDATE')}
							onClick={() => selectedItem?.postId && postSvc.approve(selectedItem.postId).done(reload)}
						>
							Approve post
						</Button>
					)}

					<Button
						fullWidth
						variant="contained"
						color="warning"
						disabled={!auth.can('post', 'DELETE')}
						onClick={() => selectedItem?.postId && postSvc.delete(selectedItem.postId).done(reload)}
					>
						Delete post
					</Button>
				</Row>
			) : null}
		</Col>
	);
});
